export enum PayGateCommonPaymentStatus {
  UNKNOWN = "UNKNOWN",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCEEDED = "SUCCEEDED",
  DEFERRED = "DEFERRED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
}

export default class GooglePayInitPaymentResponse {
  paymentStatus: PayGateCommonPaymentStatus;
  browserFingerprintActionUrl?: string;
}
